import React, { useEffect } from 'react';
import { useNavigation } from '../../../navigation/native';

import Layout from '../Layout';
import {
  editingActions,
  selectLogDetailError,
  selectShiftLogDetails,
  shiftLogActions,
} from '../../../store';
import { Snippet } from '../../../services/dataModels';
import { navigateToSnippet } from '../helpers';
import Link from '../Link';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store/store';
import { Route } from '../../../app/Route';
import { displayInformationAlert } from '../../../helpers/Functions';

const ShiftLogDetailsScreen = () => {
  const navigation = useNavigation();
  const dispatch = useDispatch<AppDispatch>();

  const shiftLogDetails = selectShiftLogDetails.useHook();
  const errorMessage = selectLogDetailError.useHook();

  useEffect(() => {
    if (errorMessage)
      displayInformationAlert({
        title: 'Error',
        description: errorMessage,
        onOk: () => dispatch(shiftLogActions.resetShiftLogDetailErrorMessage()),
      });
  }, [dispatch, errorMessage]);

  const handleLinkPressed = (snippet: Snippet) => {
    dispatch(editingActions.editedSnippetChanged(snippet));
    navigateToSnippet(navigation, snippet, {
      snippetId: snippet.shiftsummaryDisplyId,
      lastLink: snippet.displayName,
    });
  };

  return (
    <Layout
      title={'Shift Log Details'}
      onCancel={() => navigation.navigate(Route.reportScreen)}
      content={
        <>
          {shiftLogDetails.snippets.map((snippet, index) => (
            <Link
              key={index}
              name={snippet.displayName}
              handlePress={() => handleLinkPressed(snippet)}
            />
          ))}
        </>
      }
    />
  );
};

export default ShiftLogDetailsScreen;
